import InfiniteTree from './InfiniteTree';

module.exports = InfiniteTree;



// WEBPACK FOOTER //
// ../src/index.js